import React from 'react';

const CompanySizeIcon = function CompanySizeIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className='company-size-icon'>
      <path d="M10.3935 0.25H7.0754C6.83045 0.25 6.63003 0.45042 6.63003 0.695377C6.63003 0.940335 6.83045 1.14075 7.0754 1.14075H9.33569L1.14075 9.32456V7.06427C1.14075 6.81931 0.940335 6.61889 0.695377 6.61889C0.45042 6.61889 0.25 6.81931 0.25 7.06427V10.3823C0.25 10.6273 0.45042 10.8277 0.695377 10.8277H4.01344C4.13592 10.8277 4.24726 10.7832 4.3252 10.6941C4.40314 10.6162 4.45881 10.5048 4.45881 10.3823C4.45881 10.1374 4.25839 9.93695 4.01344 9.93695H1.76428L9.95922 1.75315V4.0023C9.95922 4.24726 10.1596 4.44768 10.4046 4.44768C10.5271 4.44768 10.6384 4.40314 10.7164 4.31407C10.7943 4.23613 10.85 4.12478 10.85 4.0023V0.695377C10.8388 0.45042 10.6384 0.25 10.3935 0.25Z" fill="#7E7E7E" stroke="#7E7E7E" stroke-width="0.5" />
    </svg>

  );
};

export default CompanySizeIcon;